import * as Tabs from "@radix-ui/react-tabs";
import React from "react";
import { FormattedMessage } from "react-intl";
import { useHistory, useLocation } from "react-router-dom";

import { EventsTabsList, EventsTabsTrigger } from "~/components/doctor/events/event_list_shared";
import { Layout } from "~/components/ui/layout";
import { Portlet, PortletTitle } from "~/components/ui/portlet";

export function MeetingsLayout({ children }: { children: React.ReactElement }) {
  const location = useLocation();
  const history = useHistory();

  const isMeetingsPath = /^\/pages\/meetings\/?$/.test(location.pathname);
  const isEnrolledPath = /^\/pages\/meetings\/enrolled/.test(location.pathname);

  const meetingsPath = "/pages/meetings";
  const enrolledPath = "/pages/meetings/enrolled";

  const value = isMeetingsPath ? meetingsPath : isEnrolledPath ? enrolledPath : location.pathname;

  return (
    <Layout contentClassName="max-sm:-tw-mx-2 max-sm:-tw-my-6">
      <Portlet as="main">
        <PortletTitle iconClassName="icon-calendar">
          <FormattedMessage id="meetings.title" />
        </PortletTitle>

        <Tabs.Root value={value} onValueChange={history.push}>
          <EventsTabsList hrMarginX={false} topPaddingY={false} style={{ paddingTop: 2 }}>
            <EventsTabsTrigger isActive={isMeetingsPath} value={meetingsPath}>
              <FormattedMessage id="meetings.available" />
            </EventsTabsTrigger>

            <EventsTabsTrigger isActive={isEnrolledPath} value={enrolledPath}>
              <FormattedMessage id="meetings.booked" />
            </EventsTabsTrigger>
          </EventsTabsList>

          <div className="porlet-body tw-min-h-[50vh] tw-flex tw-flex-col">{children}</div>
        </Tabs.Root>
      </Portlet>
    </Layout>
  );
}
